import { render, staticRenderFns } from "./SortSelect.vue?vue&type=template&id=9fc004fe&scoped=true"
import script from "./SortSelect.ts?vue&type=script&lang=ts&external"
export * from "./SortSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./SortSelect.vue?vue&type=style&index=0&id=9fc004fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc004fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fc004fe')) {
      api.createRecord('9fc004fe', component.options)
    } else {
      api.reload('9fc004fe', component.options)
    }
    module.hot.accept("./SortSelect.vue?vue&type=template&id=9fc004fe&scoped=true", function () {
      api.rerender('9fc004fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/NoContract/components/SortSelect/SortSelect.vue"
export default component.exports